
const columnList: Array<column> = [
    {
        prop: "work_name",
        label: "设置项",
        width: 355,
    },
    {
        prop: "work_value",
        label: "值",
        width: 355,
    },
    {
        prop: "work_desc",
        label: "值备注",
        width: 355,
    },
];
import {
    defineComponent,
    ref,
    reactive,
    inject,
    onMounted,
    watch,
    Ref,
} from "vue";
import { Request } from "@/api/request";
import { column } from "@/assets/types/common";

export default defineComponent({
    name: "Worksheet",
    setup() {
        let tableData = ref([]),
            loading = ref(false),
            headClass = inject("headClass"),
            dialogVisible = ref(false),
            selectData = ref([]),
            formRef = ref(null),
            form = ref({
                // 1: "1",
                // 2: "1",
                // 3: "1",
                // 4: "1",
                // 5: "1",
                // 6: "1",
                deaudit: "0",
                carcoderegion: ["京", "A"],
                carordernum:"0"
                // 9: "",
                // 10: "1",
                // 11: "",
                // 12: "",
                // 13: "",
                // 14: "",
                // 15: "",
                // 16: "",
                // 17: "",
                // 18: "1",
            } as any),
             // rules = ref({
             //    province: [
             //        { required: true, message: "必填", trigger: "change" },
             //    ],
             //    9: {
             //        required: true,
             //        message: "请输入质保天数",
             //        trigger: "change",
             //    },
             //    11: {
             //        required: true,
             //        message: "请输入检车间隔天数",
             //        trigger: "change",
             //    },
             // }),
            provinceList = [
                "京",
                "津",
                "冀",
                "晋",
                "蒙",
                "辽",
                "吉",
                "黑",
                "沪",
                "苏",
                "浙",
                "皖",
                "闽",
                "赣",
                "鲁",
                "豫",
                "鄂",
                "湘",
                "粤",
                "桂",
                "琼",
                "渝",
                "川",
                "贵",
                "云",
                "藏",
                "陕",
                "甘",
                "青",
                "宁",
                "新",
            ],
            getTableData = (): void => {
                loading.value = true;

                Request.axiosInstance({
                    url: "adminapi/Operate/workSetupList",
                    data: {},
                }).then((res: any) => {
                    loading.value = false;
                    if (res.status == 200) {
                        tableData.value = res.content.list;
                        //console.log('tableData---',tableData.value)
                        tableData.value.forEach((item: any, index) => {
                            form.value[item.work_english] = item.true_value;
                            // if(item.work_id == 8){
                            //   form.value.carcoderegion = item.work_return
                            // }
                        });
                        //console.log('form---',form.value)
                    }
                });
            },
            workSetupSetUp = () => {
                //console.log(form.value);return
                //(formRef.value as any).validate((valid: boolean) => {
                   // if (valid) {
                        let list: any = [];
                        tableData.value.forEach((item: any, index) => {
                            if (item.work_id == 8) {
                                list.push({
                                    id: item.work_id,
                                    value:
                                        form.value.carcoderegion[0] +
                                        form.value.carcoderegion[1],
                                });
                            } else {
                                list.push({
                                    id: item.work_id,
                                    value: form.value[item.work_english],
                                });
                            }
                        });
                        
                        Request.axiosInstance({
                            url: "adminapi/Operate/workSetupSetUp",
                            data: {
                                list,
                            },
                        }).then((res: any) => {
                            getTableData();
                            dialogVisible.value = false;
                            // selectData.value = res?.content?.list || [];
                        });
                 //   }
                //});
            };
        onMounted(() => {
            getTableData();
            Request.axiosInstance({
                url: "adminapi/Basicset/totalList",
                data: {
                    basicset_type: 10,
                },
            }).then((res: any) => {
                selectData.value = res?.content?.list || [];
            });
        });
        return {
            columnList,
            headClass,
            loading,
            tableData,
            dialogVisible,
            formRef,
            form,
            provinceList,
            //rules,
            selectData,
            workSetupSetUp,
        };
    },
});
